import { APIURL } from "../models/api-base";
import {
    apiUrl_statistics_total_post,
    apiUrl_statistics_total_active_memberships,
    apiUrl_statistics_total_first_time_active_members,
    apiUrl_statistics_total_returning_active_members,
    apiUrl_statistics_active_memberships_by_year,
    apiUrl_statistics_active_memberships_by_month,
    apiUrl_statistics_active_memberships_by_product,
    apiUrl_statistics_active_memberships_by_day,
    apiUrl_statistics_membership_managed_years,
} from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
    constructor() {
        super(APIURL);
    }

    getTotalPosts = async () => {
        try {
            const response = await this.get(apiUrl_statistics_total_post);
            return { data: response.data.total_registros, error: null };
        } catch (err) {
            return { data: null, error: err.response?.data?.message || err.message };
        }
    };

    getTotalActiveMemberships = async () => {
        try {
            const response = await this.get(apiUrl_statistics_total_active_memberships);
            return {
                data: response.data.total_users_with_active_membership,
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getTotalFirstTimeActiveMembers = async () => {
        try {
            const response = await this.get(apiUrl_statistics_total_first_time_active_members);
            return {
                data: response.data.total_first_time_active_members,
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getTotalReturningActiveMembers = async () => {
        try {
            const response = await this.get(apiUrl_statistics_total_returning_active_members);
            return {
                data: response.data.total_returning_active_members,
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getActiveMembershipsByYear = async () => {
        try {
            const response = await this.get(apiUrl_statistics_active_memberships_by_year);
            return {
                data: response.data ?? [],
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getMembershipManagedYears = async () => {
        try {
            const response = await this.get(apiUrl_statistics_membership_managed_years);
            // Se excluye 2099: es el año de fin de la membresía infinita asignada a los super admin
            const years = (response.data ?? []).filter((item) => item.year !== 2099);
            return {
                data: years,
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getActiveMembershipsByMonth = async (year) => {
        try {
            const response = await this.get(`${apiUrl_statistics_active_memberships_by_month}/${year}`);
            return {
                data: response.data ?? [],
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getActiveMembershipsByProduct = async (year, month) => {
        try {
            const path =
                month != null
                    ? `${apiUrl_statistics_active_memberships_by_product}/${year}/${month}`
                    : `${apiUrl_statistics_active_memberships_by_product}/${year}`;
            const response = await this.get(path);
            return {
                data: response.data ?? [],
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };

    getActiveMembershipsByDay = async (year, month) => {
        try {
            const response = await this.get(`${apiUrl_statistics_active_memberships_by_day}/${year}/${month}`);
            return {
                data: response.data ?? [],
                description: response.description ?? null,
                error: null,
            };
        } catch (err) {
            return { data: null, description: null, error: err.response?.data?.message || err.message };
        }
    };
}

const StatisticsService = new Service();
export default StatisticsService;
